import { render, staticRenderFns } from "./InsurancesPlanDetailsFloatBtns.vue?vue&type=template&id=48a452de&"
import script from "./InsurancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports